/**
 * getShopNameApply
 * Kiểm tra shopName hiên tại  có phải trường hợp muốn triển khai Atom mới hay không;
 * @param currentName : tên shop hiện tại muốn so khớp
 * @param chars (Array) các kí tự đầu tiên của tên các shop muốn áp dụng
 * @returns đúng hoặc sai
 */
export function getShopNameApply(currentName: string, chars: Array<string>): boolean {
  if (!chars) {
    chars = [];
  }
  let result = false;
  if (currentName && currentName.length > 0) {
    for (let i = 0; i < chars.length; i++) {
      const char = chars[i];
      const len = char.length;
      const sub = currentName.substr(0, len);
      if (char == sub) {
        result = true;
        break;
      }
    }
  }
  return result;
}
